import React from 'react';
import { CheckCircle, Clock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Benefits() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center" data-id="element-17">
        <h2 className="text-2xl md:text-5xl font-black text-white mb-6 md:mb-8 leading-tight" data-id="element-18">
          Una solución pensada para resolver el verdadero problema de{' '}
          <span className="highlight-yellow text-white block md:inline mt-1 md:mt-0" data-id="element-19">
            enseñar Programación.
          </span>
        </h2>

        <p className="text-lg md:text-2xl text-gray-300 mb-10 md:mb-16 font-medium max-w-3xl mx-auto" data-id="element-20">
          Sin tener que simplificar conceptos sobre la marcha.
        </p>

        <div className="text-left max-w-2xl mx-auto mb-10 md:mb-16" data-id="element-21">
          <div className="bg-dark-800 p-6 md:p-12 rounded-3xl border-2 border-dark-700 text-center shadow-xl" data-id="element-22">
            <p className="text-xl md:text-3xl font-bold text-gray-200 mb-6 md:mb-8" data-id="element-23">
              Simplemente:
            </p>
            <div className="flex flex-col gap-4 md:gap-6 text-lg md:text-2xl font-black text-brand-300" data-id="element-24">
              <p data-id="element-25">1️⃣ abrís el sistema</p>
              <p data-id="element-26">2️⃣ elegís el tema</p>
              <p className="text-xl md:text-3xl text-brand-400 mt-1 md:mt-2" data-id="element-27">
                3️⃣ y ya tenés la clase lista para enseñar
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-28">
          <CTAButton data-id="element-29" />
        </div>
      </div>
    </section>;
}